import { render, staticRenderFns } from "./MonitoringOrder.vue?vue&type=template&id=a60c35a6&"
import script from "./MonitoringOrder.vue?vue&type=script&lang=js&"
export * from "./MonitoringOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports